import { render, staticRenderFns } from "./GoogleAdsTasks.vue?vue&type=template&id=5d188a2f&scoped=true&"
import script from "./GoogleAdsTasks.vue?vue&type=script&lang=js&"
export * from "./GoogleAdsTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d188a2f",
  null
  
)

export default component.exports